import React from 'react';
import ReactModal from 'react-modal';
import { clsx } from '../../../utils/helper';

ReactModal.setAppElement('#root');

const BaseModal = ({
    children,
    overlayClassName,
    contentClassName,
    centered,
    ...props
}) => {
    return (
        <ReactModal
            overlayClassName={clsx('base-modal-overlay', overlayClassName)}
            className={clsx('base-modal-content', centered && 'centered', contentClassName)}
            {...props}
        >
            {children}
        </ReactModal>
    );
};

export default BaseModal;